import { type FC } from "react";

import { type MeFragment } from "@app_schema";

import { Avatar } from "@styled/avatar";

export const MenuProfileAvatar: FC<{
  me?: MeFragment;
}> = ({ me }) => <Avatar user={me} raised />;
